export default __webpack_public_path__ + "static/media/camera.4909ac03.svg";